<template>
  <el-dialog
    title="编辑"
    :visible.sync="dialog"
    width="50%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <el-form ref="formRef" :model="form" label-width="100px" label-position="right" :rules="rules" class="custom-form">
      <el-form-item label="开票发票号" prop="kpfph">
        <el-input v-model="form.kpfph" placeholder="请输入开票发票号"></el-input>
      </el-form-item>
      <el-form-item label="是否开票" prop="sfkp">
        <el-radio-group v-model="form.sfkp">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { defineComponent, reactive, ref, watch } from '@vue/composition-api'

export default defineComponent({
  name: 'OutboundEdit',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => {
      }
    },
    submitLoading: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const form = reactive({
      kpfph: '',
      sfkp: 1
    })
    const formRef = ref(null)
    const rules = {
      kpfph: [
        { required: true, message: '开票发票号不能为空', trigger: 'blur' }
      ],
      sfkp: [
        { required: true, message: '是否开票不能为空', trigger: 'change' }
      ]
    }
    const handleSubmit = () => {
      formRef.value.validate(valid => {
        if (valid) {
          emit('submit', form)
        }
      })
    }
    const handleClose = () => emit('close')
    watch(() => props.formData, (val) => {
      if (!val || typeof val !== 'object') return
      Object.keys(val).forEach((key) => {
        if (key in form) {
          const value = val[key]

          // 判断 value 是否为字符串形式的纯数字
          form[key] = typeof value === 'string' && !isNaN(value)
            ? Number(value)
            : value
        }
      })
    }, { deep: true })

    return {
      form,
      formRef,
      rules,
      handleSubmit,
      handleClose
    }
  }
})
</script>
